import React, { lazy, Suspense } from 'react';

const LazyUserIdList = lazy(() => import('./UserIdList'));

const UserIdList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyUserIdList {...props} />
  </Suspense>
);

export default UserIdList;
